import { DatePipe } from '@angular/common';
import { FiltrosSolicitudes } from './../../models/FiltrosSolicitudes';
import { HttpErrorResponse } from '@angular/common/http';
import { SolicitudService } from './../../service/solicitud/solicitud.service';
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import Swal from "sweetalert2";

@Component({
  selector: 'app-consulta-estado',
  templateUrl: './consulta-estado.component.html',
  styleUrls: ['./consulta-estado.component.scss']
})
export class ConsultaEstadoComponent implements OnInit {

  DTOFiltrosSolicitudes: FiltrosSolicitudes = new FiltrosSolicitudes();

  form: FormGroup;
  loading: boolean = false;
  loadingEstado: boolean = false;
  dataEstado :any = [];
  repRespuesta:any = [];
  dataResp :any = [];

  constructor(
    private solicitudService: SolicitudService,
    private datePipe: DatePipe,
  ) {
   
  }

  ngOnInit() {
    this.form = new FormGroup({
      
      TipoDocumentoIdentidad: new FormControl('D', []),
      NroDocumentoIdentidad: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d{7,10}$/)]),
      Codigo: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d{7,15}$/)]),

      EstadoRespuesta:new FormControl({ value: "", disabled: true}, []),
      CodigoRespuesta:new FormControl({ value: "", disabled: true}, []),
      FechaRespuesta:new FormControl({ value: "", disabled: true}, []),
    });
    this.ObtenerListaRespuestas();
    
  }

  enviar() {
    this.loading = true;
    
    this.loadingEstado = false;
    this.DTOFiltrosSolicitudes.TipoDocumentoIdentidad = this.form.controls["TipoDocumentoIdentidad"].value;
    this.DTOFiltrosSolicitudes.NroDocumentoIdentidad = this.form.controls["NroDocumentoIdentidad"].value;
    this.DTOFiltrosSolicitudes.Codigo = this.form.controls["Codigo"].value;
   
    this.solicitudService.obtenerEstadoSolicitud(this.DTOFiltrosSolicitudes)
    .subscribe(resp => {
      this.loading = false;
      this.loadingEstado = true;
      this.dataEstado = resp;
      if (this.dataEstado.length > 0) {
      this.dataResp =this.filterAccesosOfId();
      this.form.controls['EstadoRespuesta'].setValue(this.dataEstado[0]['Estado_Dsc'])
      this.form.controls['FechaRespuesta'].setValue(this.datePipe.transform(this.dataEstado[0]['FechaRegistro'],"dd-MM-yyyy"))
      }
      
    },(err: HttpErrorResponse)=> {
      this.loading = false;

      Swal.fire({
        title: 'Error',
        text: "ESTADO DE SOLICITUD NO OBTENIDO.",
        icon: "error",
        allowOutsideClick: true
      })
    });
  }

  ObtenerListaRespuestas(){

    this.solicitudService.ObtenerListadoRespuestas()
          .subscribe( resp => { 
            this.repRespuesta = resp
          }, (err: HttpErrorResponse)=> {
            console.log('Respuesta no obtenido',err)
          })
  }

  filterAccesosOfId(){
    return this.repRespuesta.filter(x => x.idSolicitud== this.dataEstado[0]['idSolicitud']);  
  }

  obtenerpdf($file:any){
    window.open($file,"_blank");
  }

}
